import { useExperiments } from '@wix/fe-essentials-standalone';
import { FunctionComponent, useCallback, useContext, useEffect } from 'react';
import { EXPERIMENTS } from '../../constants';
import { useBI } from '../../hooks/useBI';
import { abLabelTesting } from '@wix/bi-logger-new-help-center/v2';
import { mapPageTypeToSourceName } from '../../utils/bi';
import { useHistoryContext } from '../../hooks/useRouteHistory';
import { useRouter } from 'next/router';
import { Context } from '../../context';
import { PageType } from '../../types';

type ABvisibleElementProps = {
  pageType: PageType;
};

const ABvisibleElement: FunctionComponent<ABvisibleElementProps> = ({
  pageType,
}) => {
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();
  const { pageTemplateData } = useContext(Context);
  const { prePageUrl } = useHistoryContext();
  const { experiments } = useExperiments({ suspense: true, readOnly: true });
  const isB = experiments.get(EXPERIMENTS.SPECS.HELP_CENTER_AB) === 'B';

  const sendEvent = useCallback(async () => {
    await sendBIEvent(
      abLabelTesting({
        item_id: pageTemplateData.itemId,
        kb_lang: locale,
        referral_url: prePageUrl,
        source_name: mapPageTypeToSourceName(pageType),
      })
    );
  }, [sendBIEvent, locale, pageType, pageTemplateData.itemId]);

  useEffect(() => {
    if (isB) {
      void sendEvent();
    }
  }, [pageType, isB]);

  return <></>;
};

export default ABvisibleElement;
